import React from "react";

// Chakra imports
import { Badge, Icon, Flex, Button, Text, CloseButton } from "@chakra-ui/react";
import { ArrowBackIcon } from '@chakra-ui/icons'

// Custom components
import Card from "../../../../components/card/Card.js";
import { VSeparator } from "../../../../components/separator/Separator";

// Assets
import { MdShare, MdEdit, MdDownload } from "react-icons/md";
import InvoiceBg from "../../../../assets/img/InvoiceBg.png";
import {maxLenghtString} from "../../../../utils/utils";

import { useNavigate } from 'react-router';

export default function Banner(props) {
  const { title, wallet, changeLayout, layoutPos, ...rest } = props;

  // Chakra Color Mode
  const navigate = useNavigate();

  return (
    <Card
      backgroundImage={InvoiceBg}
      backgroundRepeat='no-repeat'
      bgSize='cover'
      bgPosition='10%'
      p={{base:"20px", md:"60px"}}
      pt={{base:"20px", md:"40px"}}
      pb={{base:"30px", md:"30px"}}>
      <Flex mb={{ base: "60px", md: "50px" }} direction="row">
        <Flex direction='column' color='white' h='100%' w='100%' mb={{ base: "20px", md: "0px" }} cursor='pointer' onClick={() => navigate('/admin/home')}>
          <Button
            leftIcon={<ArrowBackIcon />}
            variant={'white'}
            mt="0px"
            width={'140px'}
            fontSize='xl'
            fontWeight='bold'>
            Back
          </Button>
          <Text
            mt={{ base: "10px", md: "20px" }}
            fontSize={{ base: "2xl", md: "32px", lg: "44px", xl: "44px" }}
            fontWeight='bold'>
            {title}
          </Text>
        </Flex>
        <CloseButton 
        onClick={() => navigate('/admin/home')}
        mt={{base:"0px", md:"-20px"}}/>
      </Flex>
    </Card>
  );
}
